import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Clear";
import { Box, Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Heading1 } from "../../../../common/components/styled/styled";

type Props = {
  buttonDisabled: boolean;
  onClick: () => void;
  cancelProcessing: () => void;
  showCancelButton: boolean;
};

const BulksSalaryIncreaseHeader = ({
  buttonDisabled,
  onClick,
  cancelProcessing,
  showCancelButton,
}: Props) => {
  const { t } = useTranslation("settings");

  return (
  <Grid item xs={12}>
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Heading1>{t("bulkSalaryIncrease.title")}</Heading1>
      <Button
        disabled={buttonDisabled}
        variant="contained"
        sx={{
          borderRadius: "18px",
          bgcolor: "primary.light",
          "&:hover": {
            bgcolor: (theme) => theme.palette.hover.primaryLight,
          },
        }}
        startIcon={<AddIcon />}
        // TODO: show confirmation dialog
        onClick={onClick}
      >
        {t("bulkSalaryIncrease.createBulkSalaryIncreases")}
      </Button>
      {showCancelButton && (
        <Button
          disabled={!showCancelButton}
          variant="outlined"
          color="error"
          sx={{
            borderRadius: "18px",
          }}
          startIcon={<CancelIcon />}
          // TODO: show confirmation dialog
          onClick={cancelProcessing}
        >
          {t("bulkSalaryIncrease.cancelBulkSalaryIncreases")}
        </Button>
      )}
    </Box>
  </Grid>
  );
};

export default BulksSalaryIncreaseHeader;
